import React from "react";

import { Row, Col } from "react-bootstrap";

import { Button } from "antd";

const StepButtonsGroup = ({
  prev,
  next,
  selectedAction,
  currentStep,
  handleSubmit,
  selectedRecord,
}) => {
  return (
    <Row className='evidencijeRow invert'>
      <Col xl={8} lg={10} md={12}>
        
        {currentStep < 2 && (
          <Button
            style={{ margin: 8 }}
            onClick={next}
            disabled={!selectedAction}
            variant="primary"
            type="primary"
          >
            Nastavi
          </Button>
        )}
        {currentStep > 1 && selectedAction === "unos" && (
          <Button
            disabled={!selectedRecord}
            style={{ margin: 8 }}
            onClick={handleSubmit}
            type="primary"
          >
            Spremi
          </Button>
        )}{currentStep > 1 && (
          <Button style={{ margin: 8 }} onClick={prev}
          className="ant-btn-back"
          >
            Povratak
          </Button>
        )}
      </Col>
    </Row>
  );
};

export default StepButtonsGroup;
